export class BankAccount {
  id: string;
  accountHolderName: string | null;
  accountHolderType: string | null;
  bankName: string;
  country: string;
  currency: string;
  last4: string;
  routingNumber: string;
  status: string;

  // Calculated Fields
  displayName: string;

  constructor({
    id,
    accountHolderName,
    accountHolderType,
    bankName,
    country,
    currency,
    last4,
    routingNumber,
    status,
  }: any) {
    this.id = id;
    this.accountHolderName = accountHolderName;
    this.accountHolderType = accountHolderType;
    this.bankName = bankName;
    this.country = country;
    this.currency = currency;
    this.last4 = last4;
    this.routingNumber = routingNumber;
    this.status = status;

    this.displayName = [
      bankName,
      accountHolderName,
      accountHolderType,
      last4,
    ].join(" ");
  }
}

export interface Card {
  id: string;
  brand: string;
  last4: string;
  expMonth: string;
  expYear: string;
}
